/* Oud Library draft theme. Native forms remain usable without JavaScript. */
(() => {
  'use strict';
  const runtime = window.OudLibrary;
  if (!runtime) return;
  const {config, request, parseJSON, log} = runtime;
  const root = (config.root || '/').replace(/\/?$/, '/');
  const decode = document.createElement('textarea');
  const strings = Object.fromEntries(Object.entries(config.strings || {}).map(([key,value]) => { decode.innerHTML = String(value); return [key,decode.value]; }));
  const interpolate = (template, values) => (template || '').replace(/__OL_(\w+)__/g, (_, key) => values[key] ?? '');
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: config.currency || 'GBP' }).format(value / 100);
  let cartBusy = false;
  // One shared draft for the page and drawer. Only Shopify stores the persisted note.
  let noteDraft = null;
  let noteSaved = null;
  let noteSaving = null;
  let noteTimer;
  const noteFields = () => [...document.querySelectorAll('[data-ol-cart-note]')];
  function noteStatus(state) {
    const field = document.querySelector('#ol-cart-note-drawer') || noteFields()[0];
    const fallback = {saving:'Saving your note…',saved:'Note saved.',error:'Your note could not be saved. Please try again before checkout.'};
    document.querySelectorAll('[data-ol-note-status]').forEach(node => {
      node.textContent = field?.dataset[state] || fallback[state] || '';
      node.classList.toggle('is-error', state === 'error');
    });
  }
  async function flushNote() {
    clearTimeout(noteTimer);
    if (noteSaving) {
      await noteSaving;
      if (noteDraft !== noteSaved) return flushNote();
      return;
    }
    if (noteDraft === null || noteDraft === noteSaved) return;
    const value = noteDraft;
    noteStatus('saving');
    noteSaving = request(`${root}cart/update.js`, {
      method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({note:value})
    }, 'cart_note').then(cart => {
      if ((cart.note || '') !== value) throw new Error('Order note was not confirmed.');
      noteSaved = value;
      noteFields().forEach(field => { field.defaultValue = value; field.value = noteDraft; });
      noteStatus('saved');
    }).catch(error => {
      noteStatus('error');
      throw error;
    }).finally(() => { noteSaving = null; });
    await noteSaving;
    if (noteDraft !== noteSaved) return flushNote();
  }
  function scheduleNoteSave() {
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      if (cartBusy) { scheduleNoteSave(); return; }
      flushNote().catch(() => {});
    }, 350);
  }
  document.addEventListener('input', event => {
    const field = event.target.closest('[data-ol-cart-note]');
    if (!field) return;
    if (noteSaved === null) noteSaved = field.defaultValue;
    noteDraft = field.value;
    noteFields().forEach(other => { if (other !== field) other.value = noteDraft; });
    noteStatus('saving');
    scheduleNoteSave();
  });
  document.addEventListener('focusout', event => {
    if (event.target.matches('[data-ol-cart-note]') && !cartBusy) flushNote().catch(() => {});
  });
  let returnFocus;
  function showDialog(id, trigger) {
    const dialog = document.getElementById(id);
    if (!dialog || typeof dialog.showModal !== 'function') return false;
    document.querySelectorAll('dialog[open]').forEach(other => other.close());
    returnFocus = trigger?.isConnected ? trigger : document.querySelector('[data-ol-cart-open]') || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('ol-dialog-open');
    document.querySelectorAll(`[aria-controls="${id}"]`).forEach(el => el.setAttribute('aria-expanded', 'true'));
    return true;
  }
  const initialisedDialogs = new WeakSet();
  function initialiseDialogs() { document.querySelectorAll('dialog').forEach(dialog => {
    if (initialisedDialogs.has(dialog)) return;
    initialisedDialogs.add(dialog);
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]')) document.documentElement.classList.remove('ol-dialog-open');
      document.querySelectorAll(`[aria-controls="${dialog.id}"]`).forEach(el => el.setAttribute('aria-expanded', 'false'));
      if (returnFocus?.isConnected) returnFocus.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
  }); }
  initialiseDialogs();
  document.addEventListener('shopify:section:load', initialiseDialogs);
  function track(name, detail) {
    // Consent-gated interaction hooks only. Shopify/app pixels own commerce events.
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        window.Shopify.analytics?.publish?.(`oud_library_${name}`, detail)?.catch?.(() => {});
        return true;
      }
    } catch { log('warning','optional_feature_failed',{component:'analytics'}); }
    return false;
  }
  const viewedOffers = new Set();
  const offerObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const offer = entry.target;
      if (!entry.isIntersecting || viewedOffers.has(offer.dataset.offerId)) return;
      if (track('upsell_viewed', { product_id:offer.dataset.offerProduct, placement:offer.dataset.offerPlacement })) {
        viewedOffers.add(offer.dataset.offerId); offerObserver.unobserve(offer);
      }
    });
  }, {threshold:0.5}) : null;
  function observeOffers() { document.querySelectorAll('[data-ol-offer]').forEach(offer => offerObserver?.observe(offer)); }
  document.addEventListener('visitorConsentCollected', observeOffers);
  function setCartBusy(busy) {
    cartBusy = busy;
    document.querySelectorAll('[data-ol-cart-content]').forEach(el => busy ? el.setAttribute('aria-busy','true') : el.removeAttribute('aria-busy'));
    document.querySelectorAll('.ol-cart-summary button, [data-ol-cart-quantity], [data-ol-offer-add], [data-ol-cart-note]').forEach(el => { el.disabled = busy; });
    updateCartSteps();
  }
  function updateCartSteps() {
    document.querySelectorAll('[data-ol-cart-step]').forEach(button => {
      const input = document.getElementById(button.getAttribute('aria-controls'));
      const value = Number(input?.value);
      button.disabled = cartBusy || !input || !Number.isInteger(value) ||
        (Number(button.dataset.olCartStep) < 0 ? value <= Number(input.min) : value >= Number(input.max));
    });
  }
  function updateSizeUpgrade(section, selected) {
    const panel = section.querySelector('[data-ol-size-upgrade]');
    if (!panel) return;
    panel.hidden = true;
    if (section.dataset.sizeUpgrade !== 'true' || !selected?.available) return;
    const volume = variant => { const match = variant.title.trim().match(/^(\d+(?:\.\d+)?)\s*ml(?:\s*\/\s*\d+(?:\.\d+)?\s*fl\.?\s*oz\.?)?$/i); return match ? Number(match[1]) : 0; };
    const currentVolume = volume(selected);
    if (!currentVolume) return;
    const stock = parseJSON(section.querySelector('[data-ol-size-stock]'), []);
    const variants = parseJSON(section.querySelector('[data-ol-variants]'), []);
    const larger = variants.filter(v => v.available && stock.some(s => s.id === v.id && s.in_stock) && volume(v) > currentVolume && v.price > selected.price && v.price / volume(v) < selected.price / currentVolume).sort((a,b) => volume(a) - volume(b))[0];
    if (!larger) return;
    panel.querySelector('[data-ol-upgrade-summary]').textContent = interpolate(strings.upgradeExtra, {size:larger.title, amount:money(larger.price - selected.price)});
    panel.querySelector('[data-ol-upgrade-value]').textContent = interpolate(strings.upgradeCompare, {larger:money(larger.price / volume(larger)), smaller:money(selected.price / currentVolume)});
    const button = panel.querySelector('[data-ol-size-choose]');
    button.textContent = interpolate(strings.upgradeChoose, {size:larger.title}); button.dataset.variantId = larger.id;
    panel.hidden = false;
  }
  function chooseMedia(gallery, id) {
    if (!gallery.querySelector(`[data-ol-media="${id}"]`)) return;
    gallery.querySelectorAll('[data-ol-media]').forEach(item => {
      const active = item.dataset.olMedia === String(id);
      item.hidden = !active;
      item.classList.toggle('is-active', active);
      if (!active) item.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-ol-thumb]').forEach(button => {
      const active = button.dataset.olThumb === String(id);
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
  }
  const parser = new DOMParser();
  function replaceCartSections(sections = {}) {
    offerObserver?.disconnect();
    const focusedNote = document.activeElement?.matches('[data-ol-cart-note]') ? document.activeElement : null;
    const noteSelection = focusedNote ? {id:focusedNote.id,start:focusedNote.selectionStart,end:focusedNote.selectionEnd} : null;
    const noteOpen = document.querySelector('[data-ol-note-panel]')?.open;
    for (const html of Object.values(sections)) {
      if (!html) continue;
      const doc = parser.parseFromString(html, 'text/html');
      const drawer = doc.querySelector('.ol-drawer-inner');
      if (drawer) document.querySelector('#ol-cart-drawer .ol-drawer-inner')?.replaceWith(drawer);
      const page = doc.querySelector('.ol-cart-page');
      if (page) document.querySelector('.ol-cart-page')?.replaceWith(page);
    }
    if (noteDraft !== null) noteFields().forEach(field => {field.value = noteDraft;});
    const notePanel = document.querySelector('[data-ol-note-panel]');
    if (notePanel && noteOpen !== undefined) notePanel.open = noteOpen;
    if (noteSelection) {
      const replacement = document.getElementById(noteSelection.id);
      replacement?.focus({preventScroll:true});
      replacement?.setSelectionRange(noteSelection.start,noteSelection.end);
    }
    observeOffers();
    setCartBusy(cartBusy);
    document.dispatchEvent(new CustomEvent('ol:cart-rendered'));
  }
  function updateCount(count) {
    document.querySelectorAll('[data-ol-cart-count]').forEach(node => { node.textContent = count; });
  }
  let pendingRefresh;
  async function refreshCart() {
    if (pendingRefresh) return pendingRefresh;
    pendingRefresh = flushNote().then(() => Promise.all([
      request(`${root}cart?sections=ol-cart-drawer,ol-cart`, {cache:'no-store'}, 'cart_sections'),
      request(`${root}cart.js`, {cache:'no-store'}, 'cart_read')
    ])).then(([sections, cart]) => {
      replaceCartSections(sections);
      updateCount(cart.item_count);
      return cart;
    }).finally(() => { pendingRefresh = null; });
    return pendingRefresh;
  }
  async function syncAfterAdd(sections) {
    // Shopify bundled sections avoid a second section request after every add.
    if (sections && Object.values(sections).every(Boolean)) {
      replaceCartSections(sections);
      const cart = await request(`${root}cart.js`, {cache:'no-store'}, 'cart_count');
      updateCount(cart.item_count);
      return cart;
    }
    return refreshCart();
  }
  async function changeCart(key, quantity, trigger) {
    if (cartBusy) return;
    if (!Number.isInteger(quantity) || quantity < 0 || quantity > 99 || typeof key !== 'string') { log('warning','cart_validation_failed',{reason:'quantity'}); return; }
    setCartBusy(true);
    const focusId = trigger?.id;
    const previousScroll = document.querySelector('#ol-cart-drawer .ol-cart-main')?.scrollTop || 0;
    document.querySelectorAll('[data-ol-cart-content]').forEach(el => el.setAttribute('aria-busy', 'true'));
    try {
      await flushNote();
      const cart = await request(`${root}cart/change.js`, {
        method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: ['ol-cart-drawer', 'ol-cart'], sections_url: root + 'cart' })
      });

      if (cart.sections && Object.values(cart.sections).every(Boolean)) replaceCartSections(cart.sections);
      else await refreshCart();
      updateCount(cart.item_count);
      document.querySelector('[data-ol-live]').textContent = strings.cartUpdated;
    } catch (error) {
      await refreshCart().catch(() => {});
      document.querySelectorAll('[data-ol-cart-error]').forEach(el => { el.textContent = error.message || strings.cartError; });
    } finally {
      setCartBusy(false);
      const focusTarget = (focusId && document.getElementById(focusId)) || document.querySelector('dialog[open] [data-ol-close]') || document.querySelector('.ol-cart-page h1');
      focusTarget?.focus?.({ preventScroll: true });
      const drawerBody = document.querySelector('#ol-cart-drawer .ol-cart-main');
      if (drawerBody) drawerBody.scrollTop = previousScroll;
    }
  }
  document.addEventListener('click', async event => {
    const step = event.target.closest('[data-ol-cart-step]');
    if (step) {
      event.preventDefault();
      if (cartBusy || step.disabled) return;
      const input = document.getElementById(step.getAttribute('aria-controls'));
      if (!input || !input.checkValidity()) return;
      const value = Math.max(Number(input.min), Math.min(Number(input.max), Number(input.value) + Number(step.dataset.olCartStep)));
      if (value === Number(input.value)) return;
      await changeCart(input.dataset.key, value, step);
      return;
    }
    const basketLink = event.target.closest('.ol-cart-summary a');
    if (basketLink && (noteSaving || (noteDraft !== null && noteDraft !== noteSaved))) {
      event.preventDefault();
      try { await flushNote(); window.location.assign(basketLink.href); } catch { noteStatus('error'); }
      return;
    }
    const open = event.target.closest('[data-ol-open]');
    if (open) { event.preventDefault(); showDialog(open.dataset.olOpen, open); }
    const close = event.target.closest('[data-ol-close]');
    if (close) close.closest('dialog')?.close();
    const cartLink = event.target.closest('[data-ol-cart-open]');
    if (cartLink && document.getElementById('ol-cart-drawer')?.showModal) {
      event.preventDefault();
      showDialog('ol-cart-drawer', cartLink);
      try { await refreshCart(); } catch { document.querySelector('[data-ol-cart-error]')?.replaceChildren(document.createTextNode(strings.cartError || 'Please open your basket to continue.')); }
    }
    const thumb = event.target.closest('[data-ol-thumb]');
    if (thumb) chooseMedia(thumb.closest('[data-ol-gallery]'), thumb.dataset.olThumb);
    const zoom = event.target.closest('[data-ol-zoom]');
    if (zoom) {
      const dialog = document.getElementById('ol-zoom');
      const source = zoom.querySelector('img');
      if (source && dialog) {
        const img = dialog.querySelector('img');
        // the full size picture for the enlarged view (the gallery sends phones a smaller one, 22 Oct 2026)
        img.src = (source.currentSrc || source.src).replace(/([?&]width=)\d+/, '$11500');
        img.alt = source.alt;
        showDialog('ol-zoom', zoom);
      }
    }
    const quantity = event.target.closest('[data-ol-quantity]');
    if (quantity) {
      const input = quantity.parentElement.querySelector('input');
      input.value = Math.max(Number(input.min || 1), Math.min(Number(input.max || 99), Number(input.value || 1) + Number(quantity.dataset.olQuantity)));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const upgrade = event.target.closest('[data-ol-size-choose]');
    if (upgrade && !cartBusy) {
      const select = upgrade.closest('[data-ol-product]').querySelector('[data-ol-variant]');
      const previous = select.value;
      select.value = upgrade.dataset.variantId;
      select.dispatchEvent(new Event('change', {bubbles:true}));
      select.focus({preventScroll:true});
      track('size_upgrade_selected', {from_variant_id:previous, to_variant_id:select.value});
    }
    const remove = event.target.closest('[data-ol-remove]');
    if (remove) { event.preventDefault(); await changeCart(remove.dataset.key, 0, remove); }
    const tracked = event.target.closest('[data-ol-event]');
    if (tracked) track(tracked.dataset.olEvent, { value: tracked.dataset.olValue });
    const menu = document.querySelector('.ol-mega');
    if (menu?.open && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      const menu = document.querySelector('.ol-mega[open]');
      if (menu) { menu.open = false; menu.querySelector('summary').focus(); }
    }
  });
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-ol-autosubmit]')) input.form.requestSubmit();
    if (input.matches('[data-ol-cart-quantity]') && input.checkValidity()) changeCart(input.dataset.key, Number(input.value), input);
    if (input.matches('[data-ol-gift-bag-toggle]')) { const colours = input.closest('[data-ol-gift-bag]')?.querySelector('[data-ol-gift-bag-colours]'); if (colours) colours.hidden = !input.checked; }
    if (!input.matches('[data-ol-variant]')) return;
    const section = input.closest('[data-ol-product]');
    const variants = parseJSON(section.querySelector('[data-ol-variants]'), []);
    const variant = variants.find(item => String(item.id) === input.value);
    if (!variant) return;
    const price = section.querySelector('[data-ol-price]');
    price.replaceChildren(document.createTextNode(money(variant.price)));
    if (variant.compare_at_price > variant.price) {
      const compare = document.createElement('s'); compare.textContent = money(variant.compare_at_price); price.append(compare);
    }
    const stockLabel = section.querySelector('[data-ol-stock]');
    const sizeInfo = parseJSON(section.querySelector('[data-ol-size-stock]'), []).find(item => item.id === variant.id);
    const lowLabel = variant.available && sizeInfo?.low_label;
    // a size on Essential Pre-Order's plan at zero stock says so (5 Oct 2026), as the app's button does
    stockLabel.textContent = lowLabel || (variant.available && sizeInfo?.preorder ? 'Preorder' : variant.available ? strings.available : strings.soldOut);
    stockLabel.classList.toggle('is-low', Boolean(lowLabel));
    const stickyPrice = section.querySelector('[data-ol-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = money(variant.price);
    section.querySelectorAll('[data-ol-add]').forEach(button => {
      button.disabled = !variant.available;
      button.textContent = variant.available ? strings.add : strings.soldOut;
    });
    const notice = section.querySelector('[data-ol-variant-notice]');
    if (notice) notice.hidden = !variant.title.toLowerCase().includes('early access');
    const format = section.querySelector('[data-ol-selected-format]');
    if (format) format.textContent = variant.title;
    const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); window.history.replaceState({}, '', url);
    if (variant.featured_media?.id) chooseMedia(section.querySelector('[data-ol-gallery]'), variant.featured_media.id);
    section.querySelector('[data-ol-form-status]').textContent = '';
    updateSizeUpgrade(section, variant);
    if (!input.dataset.olAuto) track('variant_selected', { variant_id: variant.id });
  });
  document.addEventListener('submit', async event => {
    if (event.target.matches('.ol-cart-form') && cartBusy) { event.preventDefault(); return; }
    if (event.target.matches('.ol-cart-form') && (noteSaving || (noteDraft !== null && noteDraft !== noteSaved))) {
      event.preventDefault();
      const cartForm = event.target, submitter = event.submitter;
      setCartBusy(true);
      try {
        await flushNote();
        setCartBusy(false);
        // Native submission carries name="note" as a second persistence safeguard.
        cartForm.requestSubmit(submitter || undefined);
      } catch {
        setCartBusy(false);
        noteStatus('error');
        document.querySelector('[data-ol-note-panel]')?.setAttribute('open','');
        noteFields()[0]?.focus();
      }
      return;
    }
    const offerForm = event.target.closest('.ol-offer-form');
    if (offerForm) {
      event.preventDefault();
      if (cartBusy || offerForm.dataset.busy || !offerForm.reportValidity()) return;
      const offer = offerForm.closest('[data-ol-offer]');
      const placement = offer.dataset.offerPlacement;
      const productId = offer.dataset.offerProduct;
      const variantId = offerForm.querySelector('[name=id]').value;
      const status = offerForm.querySelector('[data-ol-form-status]');
      const button = offerForm.querySelector('button');
      const buttonMarkup = button.innerHTML;
      setCartBusy(true); offerForm.dataset.busy = 'true'; status.textContent = ''; button.textContent = strings.adding;
      let attempted = false;
      let added = false;
      try {
        await flushNote();
        const current = await request(`${root}cart.js`, {cache:'no-store'}, 'offer_cart_check');
        if (current.items.some(item => String(item.product_id) === productId)) {
          await refreshCart();
          if (!document.getElementById('ol-cart-drawer')?.open) showDialog('ol-cart-drawer', button);
          document.querySelectorAll('[data-ol-cart-error]').forEach(el => {el.textContent = strings.alreadyInBasket;});
          return;
        }
        const body = new FormData(offerForm); body.set('sections','ol-cart-drawer,ol-cart'); body.set('sections_url',root+'cart');
        attempted = true;
        const result = await request(`${root}cart/add.js`, {method:'POST',credentials:'same-origin',body,headers:{Accept:'application/json'}});
        added = true; await syncAfterAdd(result.sections);
        track('upsell_added', {product_id:productId,variant_id:variantId,placement});
        if (!document.getElementById('ol-cart-drawer')?.open && !showDialog('ol-cart-drawer', button)) window.location.assign(root+'cart');
        if (placement !== 'product-discovery') document.querySelector('#ol-cart-drawer [data-ol-close]')?.focus({preventScroll:true});
        document.querySelector('[data-ol-live]').textContent = strings.added;
      } catch(error) {
        if (added) {window.location.assign(root+'cart'); return;}
        if (attempted) await refreshCart().catch(()=>{});
        const message = error.uncertain || error instanceof TypeError ? strings.checkBeforeRetry : (error.message || strings.addError);
        if (status.isConnected) status.textContent = message;
        document.querySelectorAll('[data-ol-cart-error]').forEach(el=>{el.textContent=message;});
      } finally {
        delete offerForm.dataset.busy; setCartBusy(false);
        if (button.isConnected) button.innerHTML = buttonMarkup;
      }
      return;
    }
    const form = event.target.closest('.ol-product-form');
    if (!form) return;
    event.preventDefault();
    if (form.dataset.busy || cartBusy || !form.reportValidity()) return;
    const section = form.closest('[data-ol-product]');
    const buttons = section.querySelectorAll('[data-ol-add]');
    const status = form.querySelector('[data-ol-form-status]');
    // Gift bag: the tick box and colour are outside the form data, so the bag goes in as its own line after the product
    const bagToggle = section.querySelector('[data-ol-gift-bag-toggle]');
    const bagId = bagToggle?.checked ? section.querySelector('[data-ol-gift-bag-colours] input:checked')?.value : '';
    const body = new FormData(form);
    if (!bagId) { body.set('sections', 'ol-cart-drawer,ol-cart'); body.set('sections_url', root + 'cart'); }
    form.dataset.busy = 'true'; setCartBusy(true);
    buttons.forEach(button => { button.disabled = true; button.textContent = strings.adding; });
    status.textContent = '';
    let added = false;
    let bagFailed = false;
    try {
      await flushNote();
      let result = await request(`${root}cart/add.js`, { method: 'POST', body, credentials: 'same-origin', headers: { Accept: 'application/json' } });
      added = true;
      if (bagId) {
        const bag = new FormData();
        bag.set('id', bagId); bag.set('quantity', '1'); bag.set('sections', 'ol-cart-drawer,ol-cart'); bag.set('sections_url', root + 'cart');
        try {
          result = await request(`${root}cart/add.js`, { method: 'POST', body: bag, credentials: 'same-origin', headers: { Accept: 'application/json' } });
          track('gift_bag_added', { variant_id: bagId });
          bagToggle.checked = false;
          section.querySelector('[data-ol-gift-bag-colours]').hidden = true;
        } catch { bagFailed = true; }
      }
      if (bagFailed) await refreshCart(); else await syncAfterAdd(result.sections);
      if (!showDialog('ol-cart-drawer', event.submitter)) window.location.assign(root + 'cart');
      document.querySelector('[data-ol-live]').textContent = strings.added;
      if (bagFailed) document.querySelectorAll('[data-ol-cart-error]').forEach(el => { el.textContent = 'Your gift bag could not be added. Please tick it again on the product page.'; });
    } catch (error) {
      if (added) { window.location.assign(root + 'cart'); return; }
      await refreshCart().catch(() => {});
      status.textContent = error.uncertain || error instanceof TypeError ? strings.checkBeforeRetry : (error.message || strings.addError);
    } finally {
      delete form.dataset.busy; setCartBusy(false);
      const selectedId = form.querySelector('[data-ol-variant]').value;
      const current = parseJSON(section.querySelector('[data-ol-variants]'), []).find(v => String(v.id) === selectedId);
      buttons.forEach(button => { button.disabled = !current?.available; button.textContent = current?.available ? strings.add : strings.soldOut; });
    }
  });
  function initialiseProduct() {
  const product = document.querySelector('[data-ol-product]');
  if (product) {
    const selectedId = product.querySelector('[data-ol-variant]').value;
    updateSizeUpgrade(product, parseJSON(product.querySelector('[data-ol-variants]'), []).find(v => String(v.id) === selectedId));
    // The 50 ml open on entry (5 Oct 2026): the section picked it, so fire the size list's change once, as a customer's pick would,
    // so Klarna's "3 payments of" line and the address follow; the analytics event is skipped for this automatic pick.
    const preSelect = product.hasAttribute('data-ol-preselected') && product.querySelector('select[data-ol-variant]');
    if (preSelect && !product.dataset.olPreselectFired) { product.dataset.olPreselectFired = '1'; preSelect.dataset.olAuto = '1'; preSelect.dispatchEvent(new Event('change', { bubbles: true })); delete preSelect.dataset.olAuto; }
  }
  observeOffers();
  if (product && 'IntersectionObserver' in window) {
    const buy = product.querySelector('.ol-buy-row');
    const sticky = product.querySelector('[data-ol-sticky]');
    product._olStickyObserver?.disconnect();
    product._olStickyObserver = new IntersectionObserver(entries => {
      const entry = entries[0];
      sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, { threshold: 0 });
    if(buy && sticky) product._olStickyObserver.observe(buy);
  }
  }
  initialiseProduct();
  // Existing theme/app events share the native section refresh, without patching fetch.
  for (const name of ['cart:updated','cart:refresh','theme:cart:loaded']) {
    document.addEventListener(name, () => {
      if (!cartBusy) refreshCart().catch(() => {});
    });
  }
  document.addEventListener('shopify:section:select', event => {
    if (event.target.querySelector('#ol-cart-drawer')) showDialog('ol-cart-drawer');
  });
  document.addEventListener('shopify:block:select', event => {
    if (event.target.closest('#ol-cart-drawer')) showDialog('ol-cart-drawer');
  });
  document.addEventListener('shopify:section:load', initialiseProduct);
  document.addEventListener('shopify:section:unload',event=>event.target.querySelector('[data-ol-product]')?._olStickyObserver?.disconnect());
  // Saved (bookmarks), 6 Oct 2026: the handles of the fragrances a visitor bookmarks, newest first, kept in this browser.
  const savedKey = 'ol-saved';
  const readSaved = () => { try { const list = JSON.parse(localStorage.getItem(savedKey) || '[]'); return Array.isArray(list) ? list.filter(handle => typeof handle === 'string' && /^[a-z0-9-]+$/.test(handle)) : []; } catch { return []; } };
  function syncSaved() {
    const saved = new Set(readSaved());
    document.querySelectorAll('[data-ol-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.has(button.dataset.olSave))));
    document.querySelectorAll('[data-ol-saved-count]').forEach(node => { node.textContent = saved.size; node.hidden = !saved.size; });
    document.querySelectorAll('[data-ol-saved-link]').forEach(link => link.setAttribute('aria-label', saved.size ? interpolate(link.dataset.labelCount, {COUNT: saved.size}) : link.dataset.label));
  }
  function writeSaved(list) {
    try { localStorage.setItem(savedKey, JSON.stringify([...new Set(list)].slice(0, 60))); } catch { log('warning','optional_feature_failed',{component:'saved'}); }
    syncSaved();
  }
  function showSavedEmpty(page) {
    page.querySelector('[data-ol-saved-status]').hidden = true;
    page.querySelector('[data-ol-saved-empty]').hidden = false;
  }
  async function renderSavedPage(page) {
    const grid = page.querySelector('[data-ol-saved-grid]'), status = page.querySelector('[data-ol-saved-status]'), list = readSaved();
    if (!list.length) return showSavedEmpty(page);
    page.setAttribute('aria-busy', 'true');
    // a missing product (deleted or unpublished) answers 404 and leaves the list; a failed request keeps it
    const cards = await Promise.all(list.map(handle => fetch(`${root}products/${handle}?view=ol-card`, {credentials:'same-origin'})
      .then(response => response.ok ? response.text() : response.status === 404 ? null : undefined).catch(() => undefined)));
    page.removeAttribute('aria-busy');
    const gone = list.filter((handle, i) => cards[i] === null);
    if (gone.length) writeSaved(readSaved().filter(handle => !gone.includes(handle)));
    grid.innerHTML = cards.filter(Boolean).join('');
    syncSaved();
    if (cards.some(card => card === undefined)) { status.textContent = page.dataset.error; status.hidden = false; }
    else if (!grid.children.length) showSavedEmpty(page);
    else status.hidden = true;
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-ol-save]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.olSave, list = readSaved(), saving = !list.includes(handle);
    writeSaved(saving ? [handle, ...list] : list.filter(item => item !== handle));
    button.classList.remove('is-saving');
    if (saving) { void button.offsetWidth; button.classList.add('is-saving'); }
    track(saving ? 'fragrance_saved' : 'fragrance_unsaved', {handle});
    // on the Saved page an unsaved card leaves the grid
    const page = button.closest('[data-ol-saved-page]'), card = button.closest('.ol-card');
    if (page && card && !saving) {
      card.classList.add('is-leaving');
      setTimeout(() => { card.remove(); if (!page.querySelector('[data-ol-saved-grid]').children.length) showSavedEmpty(page); }, matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : 200);
    }
  });
  // another tab saved or removed something
  window.addEventListener('storage', event => { if (event.key === savedKey) syncSaved(); });
  // cards that arrive later (section reloads, the cart drawer's own renders)
  let savedQueued = false;
  new MutationObserver(records => {
    if (savedQueued || !records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('[data-ol-save]') || node.querySelector('[data-ol-save]'))))) return;
    savedQueued = true;
    requestAnimationFrame(() => { savedQueued = false; syncSaved(); });
  }).observe(document.body, {childList:true, subtree:true});
  syncSaved();
  document.querySelectorAll('[data-ol-saved-page]').forEach(page => { renderSavedPage(page).catch(() => { const status = page.querySelector('[data-ol-saved-status]'); status.textContent = page.dataset.error; status.hidden = false; }); });
})();
